import React, { useEffect } from 'react';
import { ServicesSection } from '../components/ServicesSection';
import { StrategySection } from '../components/StrategySection';
import { MediaSection } from '../components/MediaSection';
export function ServicesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24" data-id="element-400">
      <ServicesSection data-id="element-401" />
      <StrategySection data-id="element-402" />
      <MediaSection data-id="element-403" />
    </div>;
}